import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-individual-miles',
    templateUrl: './individual-miles.component.html',
    styleUrls: ['./individual-miles.component.css']
})
export class IndividualMilesComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    public isRoundTrip = false;

    public form: FormGroup;

    constructor(protected footerService: FooterNavbarService,
                protected emissionService: EmissionService,
                private fb: FormBuilder,
                protected spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.form = this.fb.group({
            mileShort: [0, this.getValidationParameters()],
            mileMedEcon: [0, this.getValidationParameters()],
            mileMedFirst: [0, this.getValidationParameters()],
            mileLongEcon: [0, this.getValidationParameters()],
            mileLongEconPlus: [0, this.getValidationParameters()],
            mileLongBusiness: [0, this.getValidationParameters()],
            mileLongFirst: [0, this.getValidationParameters()],
            roundTrip: [true, [Validators.required]]
        });
    }

    next(): void {
        let calculatorName = Constants.calculators.individual;
        let categoryName = Constants.categories.individual.travel;
        let params = {
            calculateBy: 'byMiles',
            roundLongBusiness: this.getFV('roundTrip'),
            roundLongEcon: this.getFV('roundTrip'),
            roundLongEconPlus: this.getFV('roundTrip'),
            roundLongFirst: this.getFV('roundTrip'),
            roundLongSU: this.getFV('roundTrip'),
            roundMedEcon: this.getFV('roundTrip'),
            roundMedFirst: this.getFV('roundTrip'),
            roundMedSU: this.getFV('roundTrip'),
            roundShort: this.getFV('roundTrip'),
            mileShort: this.getFV('mileShort'),
            mileMedEcon: this.getFV('mileMedEcon'),
            mileMedFirst: this.getFV('mileMedFirst'),
            mileLongEcon: this.getFV('mileLongEcon'),
            mileLongEconPlus: this.getFV('mileLongEconPlus'),
            mileLongBusiness: this.getFV('mileLongBusiness'),
            mileLongFirst: this.getFV('mileLongFirst'),
            mileMedSU: 0,
            mileLongSU: 0
        };

        if (!!+params.mileShort || !!+params.mileMedEcon || !!+params.mileMedFirst || !!+params.mileLongEcon ||
            !!+params.mileLongEconPlus || !!+params.mileLongBusiness || !!+params.mileLongFirst) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];

                    this.emissionService.setEmission({
                        category: categoryName,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });
                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: categoryName,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });
            this.footerService.skip();
        }
    }

    private getValidationParameters() {
        return [Validators.required, CustomValidators.min(0), CustomValidators.max(999999),
            CustomValidators.digits];
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-miles/individual-miles.component.ts